import React from 'react';
import PropTypes from 'prop-types';
import {TableColumnAlignment, TableColumnStyle, TableColumnWidth} from './Table.styled';

export const TableColumn = React.memo(function TableColumn({
	children,
	wrapped,
	width,
	align,
	visible,
	level,
	canExpand,
	borderLeft,
	borderRight,
	usePadding,
	background,
	userpilot,
	cy,
	bold,
	negative,
	greyedOut,
	wrapText = false,
}) {
	if (!visible) {
		return null;
	}
	const column = (
		<TableColumnStyle
			wrapped={wrapped}
			borderLeft={borderLeft}
			borderRight={borderRight}
			width={width}
			level={level}
			align={align}
			canExpand={canExpand}
			usePadding={usePadding}
			background={background}
			data-userpilot={userpilot}
			data-cy={cy}
			bold={bold}
			negative={negative}
			greyedOut={greyedOut}
			wrapText={wrapText}
		>
			{children}
		</TableColumnStyle>
	);
	return column;
});

TableColumn.propTypes = {
	children: PropTypes.node,
	width: PropTypes.oneOf(Object.values(TableColumnWidth)),
	align: PropTypes.oneOf(Object.values(TableColumnAlignment)),
	visible: PropTypes.bool.isRequired,
	level: PropTypes.oneOf([1, 2, 3, 4, 5]),
	canExpand: PropTypes.bool,
	borderLeft: PropTypes.bool,
	borderRight: PropTypes.bool,
	usePadding: PropTypes.bool,
	background: PropTypes.oneOf(['GREY']),
	wrapped: PropTypes.bool,
	userpilot: PropTypes.string,
	cy: PropTypes.string,
	bold: PropTypes.bool,
	negative: PropTypes.bool,
	greyedOut: PropTypes.bool,
	wrapText: PropTypes.bool,
};

TableColumn.defaultProps = {
	visible: true,
};
